import {
  arrow,
  autoUpdate,
  flip,
  offset,
  shift,
  useDismiss,
  useFloating,
  useFocus,
  useHover,
  useInteractions,
  useRole,
} from '@floating-ui/react';
import * as React from 'react';

export function usePopoverInteractions({
  open,
  onOpenChange,
  hoverDelay,
  role = 'dialog',
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  hoverDelay: { open: number; close: number };
  role?: React.AriaRole;
}): {
  refs: any;
  floatingStyles: React.CSSProperties | undefined;
  context: any;
  getReferenceProps: any;
  getFloatingProps: any;
  arrowRef: any;
  middlewareData: any;
  placement: any;
} {
  const arrowRef = React.useRef<HTMLElement | null>(null);

  const middleware = React.useMemo(
    () => [offset(5), flip(), shift(), arrow({ element: arrowRef })],
    []
  );

  const { refs, floatingStyles, context, middlewareData, placement } =
    useFloating({
      open,
      onOpenChange,
      middleware,
      whileElementsMounted: autoUpdate,
    });

  const hover = useHover(context, { delay: hoverDelay });
  const focus = useFocus(context);
  const dismiss = useDismiss(context);
  const roleInteraction = useRole(context, { role: role as any });

  const { getReferenceProps, getFloatingProps } = useInteractions([
    hover,
    focus,
    dismiss,
    roleInteraction,
  ]);

  return {
    refs,
    floatingStyles,
    context,
    getReferenceProps,
    getFloatingProps,
    arrowRef,
    middlewareData,
    placement,
  };
}
